import React, { useContext, useRef, useState } from "react";
import "../Styles/HampiReset.css";
import { useFormik } from "formik";
import * as yup from "yup";
import { CircularProgress, IconButton, Switch, TextField } from "@mui/material";
import logo1 from "../Images/LogoChangeBGRemoved.png";
import { Info } from "@phosphor-icons/react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import ToastComponent from "../components/ToastComponent";
import isGuestUser from "../utils/guestUser";
import {
  clientApiUrl,
  taskApiUrl,
  notificationApiUrl,
  userApiUrl,
} from "../utils/GetUrl";
// import MuiTooltip from '../Component/Tool_tip1';

const passwordRegexp = new RegExp(
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_])(?=.{6,20}$)"
);
const validationSchema = yup.object({
  NewPassword: yup
    .string("Enter your password")
    .matches(passwordRegexp, "Password is not valid")
    .required("Password is required"),
  ConfirmNewPassword: yup
    .string("Enter your password")
    .oneOf([yup.ref("NewPassword"), null], "Passwords must match")
    .required("Password is required"),
});

export default function HampiReset() {
  const [loading, setLoading] = useState(false);
  const [invalidPassword, setInvalidPassword] = useState(false);
  const [isInfoMenuOpen, setIsInfoMenuOpen] = useState(false);
  const { userData, token } = useContext(AuthContext);
  const { handleAuthExpiry, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const user = userData?.[0];
  const toastRef = useRef();
  //console.log(token);

  const formik = useFormik({
    initialValues: {
      NewPassword: "",
      ConfirmNewPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: async () => {
      // setLoading(true);
      //console.log(formik.values);
      handleResetPassword(formik.values);
    },
  });

  const handleResetPassword = async (values) => {
    setLoading(true);

    if (isGuestUser(userData?.[0]?.DRM_ID)) {
      toastRef.current.showToast(`Guest User Does not have Add or Edit Access`);

      return;
    }
    try {
      const response = await fetch(`${userApiUrl}/UpdateEmp`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          UserID: user?.EM_ID,
          employeeId: user?.EM_EmpID,
          firstName: user?.EM_FirstName,
          lastName: user?.EM_LastName,
          joiningDate: user?.EM_JoiningDate,
          // "terminationDate": user?.EM_TerminationDate,
          email: user?.EM_EmailId,
          passWord: values.NewPassword,
          designationId: parseFloat(user?.EM_Designation),
          departmentId: parseFloat(user?.EM_Department),
          ModifiedById: user?.EM_ID,
          roleId: user?.DRM_ID ? user.DRM_ID.split(",").map(Number) : [],
          teamId: parseFloat(user?.STM_Team),
          subTeamId: parseFloat(user?.STM_Subteam),
          qualityConsultantId: user?.STM_QC,
          processLeadId: user?.STM_PL,
          departmentLeadId: user?.STM_DM_Head,
          managerId: user?.STM_Manager,
        }),
      });
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }
      setLoading(false);
      //console.log(data);
      toastRef.current.showToast("Password Reset  Successfully", "success");
      await new Promise((resolve) => setTimeout(resolve, 2000));
      navigate("/dashboard");
    } catch (error) {
      console.error("Error resetting password:", error.message); // Log the error message
      toastRef.current.showToast(
        "Error resetting Password. Please try Again",
        "error"
      );
      setLoading(false);
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [passwordEntered, setPasswordEntered] = useState(false);
  const [passwordEntered1, setPasswordEntered1] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const handleTogglePassword1 = () => {
    setShowPassword1(!showPassword1);
  };
  const handlePasswordChange = (event) => {
    const value = event.target.value;
    setPasswordEntered(value !== "");
  };
  const handlePasswordChange1 = (event) => {
    const value = event.target.value;
    setPasswordEntered1(value !== "");
  };
  const toggleInfoMenu = () => {
    setIsInfoMenuOpen(!isInfoMenuOpen);
  };

  const closeInfoMenu = () => {
    setIsInfoMenuOpen(false);
  };

  return (
    <div className="main-l">
      <div className="Container-r">
        <div>
          <div className="img11">
            <img className="img-logo1" loading="lazy" src={logo1} alt="" />
          </div>
          <div className="title1">Reset Password</div>
        </div>
        <div className="main-user-info1" style={{ textAlign: "center", padding: "24px 0" }}>
          <p style={{ fontSize: "15px", color: "#50145A", fontWeight: 600, marginBottom: "12px" }}>
            Passwords are managed through Microsoft Entra ID.
          </p>
          <p style={{ fontSize: "14px", color: "#555", marginBottom: "24px" }}>
            To reset your password, please use the Microsoft self-service password reset portal.
          </p>
          <a
            href="https://mysignins.microsoft.com/security-info"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "10px 24px",
              backgroundColor: "#50145A",
              color: "#fff",
              borderRadius: "6px",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            Go to Microsoft Security Settings
          </a>
          <div style={{ marginTop: "20px" }}>
            <button
              onClick={() => navigate("/dashboard")}
              style={{ background: "none", border: "none", color: "#50145A", cursor: "pointer", fontSize: "14px", textDecoration: "underline" }}
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// export default Hampi_Reset
